export * from './DeleteIcon'
